import styled from 'styled-components';
export const Container = styled.section `
  width: 100%;
  margin: 0 auto;
  text-align: center;
  max-width: 51.2rem;
  padding: 4.2rem 1.8rem 3.6rem;

  ${({ theme }) => theme.media.tablet `
    padding: 5.6rem 3.6rem 4.2rem;
    width: 51.2rem;
  `}
`;
export const IconWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;

  width: 10.3rem;
  height: 10.3rem;
  margin: 0 auto 4.2rem;
  margin-bottom: 5.8rem;
  border-radius: ${({ theme }) => theme.borderRadius.highest};
`;
export const TitleWrapper = styled.div `
  margin-bottom: 1.2rem;
`;
export const DescriptionWrapper = styled.div `
  max-width: 33rem;

  margin: 0rem auto 4.4rem;
`;
export const DownloadWrapper = styled.div `
  margin-bottom: 1.6rem;
`;
export const ButtonWrapper = styled.div `
  margin: 0 auto;
`;
//# sourceMappingURL=styles.js.map